import React, { useCallback, useContext, useEffect, useState } from 'react';
import { axios, baseUrl } from 'Api';
import { AppContext, AuthContext } from 'Context';
import { ProjectorShimmer } from 'Components';
import { ViewerPage } from '../components/page';
import styles from '../successor/index.module.css';

// Viewers → Connected Accounts. A read-only list of the accounts connected to
// this affiliate — same data the Affiliate Program panel lists, nothing else.
export const ConnectedAccounts = () => {
  const { getToken } = useContext(AuthContext);
  const { isTokenChange } = useContext(AppContext);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadUsers = useCallback(async () => {
    setLoading(true);
    try {
      const token = await getToken();
      const res = await axios.post(`${baseUrl}/inviteUsersList`, { token }).catch(() => null);
      const data = res?.data;
      const list = Array.isArray(data) ? data : (data?.data || data?.users || []);
      setUsers(Array.isArray(list) ? list : []);
    } catch (e) {
      setUsers([]);
    } finally {
      setLoading(false);
    }
  }, [getToken]);

  useEffect(() => { loadUsers(); }, [loadUsers, isTokenChange]);

  return (
    <ViewerPage title="Connected Accounts">
      <div className={styles.allViewersContainer}>
        {/* eslint-disable-next-line no-nested-ternary */}
        {loading ? (
          <ProjectorShimmer isLight />
        ) : !users.length ? (
          <p style={{
            padding: '32px 0', textAlign: 'center', color: '#6b7280', fontSize: 16, fontWeight: 600,
          }}
          >
            No connected accounts yet
          </p>
        ) : (
          <div>
            {users.map((u, idx) => {
              const name = `${u?.firstname || ''} ${u?.lastname || ''}`.trim();
              const email = u?.email || '';
              return (
                <div className={styles.userRequest} key={u?.userId || email || idx}>
                  <div>
                    <div className={styles.profileIcon}>
                      {(name || email).charAt(0).toUpperCase()}
                    </div>
                    <div className={styles.userRequestText}>
                      <div className={styles.userRequestName}>{name || '—'}</div>
                      <div className={styles.userRequestEmail}>{email}</div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </ViewerPage>
  );
};
